import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { usePersistedState } from "@/lib/persist";
import { Input } from "@/components/ui/input";
import { Search, User } from "lucide-react";
import { LaadBalk, TabelLaadRij } from "@/components/LaadIndicator";

export default function Contactpersonen() {
  const [items, setItems] = useState([]);
  const [orgs, setOrgs] = useState({});
  const [q, setQ] = usePersistedState("contactpersonen:q", "");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const perPage = 20;
  const navigate = useNavigate();

  const load = async () => {
    setLoading(true);
    try {
      const [{ data: cs }, { data: os }] = await Promise.all([
        api.get("/contactpersonen", { params: { q }}),
        api.get("/organisaties"),
      ]);
      setItems(cs);
      setOrgs(Object.fromEntries(os.map(o => [o.id, o.naam])));
      setPage(1);
    } finally { setLoading(false); }
  };
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); /* eslint-disable-next-line */ }, [q]);

  const paged = items.slice((page-1)*perPage, page*perPage);
  const totalPages = Math.max(1, Math.ceil(items.length / perPage));

  return (
    <div className="space-y-6" data-testid="contacts-page">
      <div>
        <div className="text-sm text-muted-foreground">Personen</div>
        <h1 className="font-display text-4xl font-medium tracking-tight mt-1">Contactpersonen</h1>
      </div>

      {loading && <LaadBalk label="Contactpersonen laden" />}

      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input placeholder="Zoek op naam, e-mail, functie…" className="pl-9" value={q} onChange={(e)=>setQ(e.target.value)} data-testid="contacts-search" />
      </div>

      <div className="bg-card border border-border rounded-xl overflow-hidden">
        <table className="w-full">
          <thead className="bg-secondary/50 text-xs uppercase tracking-wide text-muted-foreground">
            <tr>
              <th className="text-left p-3">Naam</th>
              <th className="text-left p-3">Functie</th>
              <th className="text-left p-3">Organisatie</th>
              <th className="text-left p-3">E-mail</th>
              <th className="text-left p-3">Telefoon</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {paged.map((c) => (
              <tr key={c.id} className="table-row-hover" onClick={()=>navigate(`/organisaties/${c.organisatie_id}`)} data-testid={`contact-row-${c.id}`}>
                <td className="p-3 font-medium flex items-center gap-2"><User className="h-4 w-4 text-muted-foreground" />{c.voornaam} {c.achternaam}</td>
                <td className="p-3 text-muted-foreground">{c.functie}</td>
                <td className="p-3">{orgs[c.organisatie_id] || "—"}</td>
                <td className="p-3 text-muted-foreground">{c.email}</td>
                <td className="p-3 text-muted-foreground">{c.telefoon || c.mobiel}</td>
              </tr>
            ))}
            {items.length === 0 && <TabelLaadRij colSpan={5} loading={loading} />}
          </tbody>
        </table>
        {totalPages > 1 && (
          <div className="flex items-center justify-between p-3 border-t border-border text-sm">
            <span className="text-muted-foreground">{items.length} resultaten · pagina {page}/{totalPages}</span>
            <div className="flex gap-2">
              <button className="px-3 py-1 border border-border rounded disabled:opacity-50" disabled={page===1} onClick={()=>setPage(p=>p-1)}>Vorige</button>
              <button className="px-3 py-1 border border-border rounded disabled:opacity-50" disabled={page===totalPages} onClick={()=>setPage(p=>p+1)}>Volgende</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
